module.exports = __webpack_public_path__ + "static/media/momo-yaoyorozu-lose.28b5ba56.png";